import { Tooltip } from '@systemeio/ui'
import { ChevronDownIcon } from '@systemeio/ui/icons'
import { TopMenuSubItem } from 'shared/components/header/components/desktop-menu/components/desktop-menu-item'
import { pageRoute } from 'shared/constants/routes.constants'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { usePermission } from 'shared/hooks/use-permission'
import { useRouter } from 'shared/hooks/use-router'
import useUser from 'shared/hooks/use-user'
import { twMerge } from 'tailwind-merge'
import { SubAccountSelector } from './sub-account-selector'

function Avatar() {
  const {
    dashboardUser,
    isWorkspaceOwner,
    isLoading,
    isDisabled,
    isSupportImpersonation,
    avatarUrl,
  } = useUser()
  const { pagePermissions } = usePermission()

  const { t } = useLocoTranslation()
  const { pathname } = useRouter()
  const shouldShowSubAccountPage = Boolean(pagePermissions[pageRoute.Subaccounts])

  const profileIsActive = pathname.includes('/profile')
  const subaccountsIsActive = pathname.includes('/subaccounts')

  if (isLoading) {
    return <div className="bg-text-secondary h-10 w-10 animate-pulse rounded-full" />
  }
  if (!dashboardUser) return null
  return (
    <Tooltip
      anchor={{
        gap: -5,
      }}
      stayOnHover={true}
      mode={'hover'}
      popoverClassName={'p-0 rounded-lg shadow-lg'}
      wrapperClassName={'h-[100%]'}
      label={
        <>
          <ul className={'text-text-tertiary flex flex-col py-4 text-sm'}>
            <>
              {!isDisabled && (
                <>
                  {isWorkspaceOwner && (
                    <li className={'flex justify-center'}>
                      <SubAccountSelector className={'mx-3 my-1 w-48'} />
                    </li>
                  )}
                  <TopMenuSubItem
                    dataTestId={'settings-link'}
                    name={t('global.settings')}
                    href={isWorkspaceOwner ? '/profile/user-settings' : '/profile/account-settings'}
                    isActive={() => profileIsActive}
                    shouldRender={true}
                  />
                  {isWorkspaceOwner && (
                    <TopMenuSubItem
                      name={t('header.user.profile.menu.sub_accounts')}
                      href={'/subaccounts'}
                      isActive={() => subaccountsIsActive}
                      shouldRender={shouldShowSubAccountPage}
                    />
                  )}
                  <hr className="text-[rgb(var(--background-tertiary))] mx-5 my-1 px-4" />
                </>
              )}

              <TopMenuSubItem
                shouldRender={isSupportImpersonation}
                isActive={() => false}
                name={t('header.exit_impersonation')}
                href={`/back/entry?pretend_this_user=_exit`}
              />
            </>
            <TopMenuSubItem
              shouldRender={true}
              isActive={() => false}
              name={t('header.user.profile.menu.logout')}
              href={`/logout`}
            />
          </ul>
        </>
      }
    >
      <div
        className={twMerge(
          `focus-visible:border-brand-primary flex h-full items-center gap-2 border-b-4 focus:outline-hidden`,
          profileIsActive || subaccountsIsActive ? 'border-brand-primary' : 'border-transparent ',
        )}
      >
        <img
          className="h-10 w-10 overflow-hidden rounded-full object-cover"
          src={avatarUrl}
          alt={`${dashboardUser.firstName} ${dashboardUser.lastName}`}
          data-test-id={'top-menu-avatar'}
        />
        <ChevronDownIcon />
      </div>
    </Tooltip>
  )
}

export default Avatar
